import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type DataTableBulkBarProps = {
	selectedCount: number;
	bulkActions: ReactNode;
};

export function DataTableBulkBar({
	selectedCount,
	bulkActions,
}: DataTableBulkBarProps) {
	const { t } = useTranslation();

	if (selectedCount === 0) return null;

	return (
		<div className="pointer-events-none absolute inset-x-0 top-0 z-20 h-10 overflow-hidden rounded-t-md">
			<div className="pointer-events-auto flex h-full items-center justify-between bg-primary px-3">
				<span className="text-sm font-medium text-primary-foreground">
					{t("dataTable.selected", { count: selectedCount })}
				</span>
				<div className="flex items-center gap-2">{bulkActions}</div>
			</div>
		</div>
	);
}
